<template>
  <div>
    <div class="recent" id="recent" v-if="start">
      <a id="back" @click="back()">戻る</a>
      <h2>最近の応募作品</h2>
      <div v-if="offline">
        ネットにつながってないかも{{('.').repeat(dotCount+1)}}
        <br />
      </div>
      <div>タイトルを押すことでその作品を読むことができます。</div>
      <a @click="tagsWindow()">タグで絞り込み{{tagswindow?'△':'▽'}}</a>
      <div v-if="tagswindow">
        <span class="tag">
          <input id="tagall" type="checkbox" v-model="selectall" @change="tagAll()" />
          <label id="alllabel" for="tagall">全タグ選択</label>
        </span>
        <span class="tag">
          <input id="tagnull" type="checkbox" v-model="selectnull" @change="tagNull()" />
          <label id="nulllabel" for="tagnull">全タグ解除</label>
        </span>
        <br />
        <span v-for="(tag, i) in tags" :key="i" class="tag">
          <input
            :id="'tag' + i"
            type="checkbox"
            :value="tag"
            v-model="selected"
            @change="tagCheck()"
          />
          <label :id="'label' + i" :for="'tag' + i">{{tag}}</label>
        </span>
      </div>
      <br />
      <a @click="selfTagsWindow()">その他から絞り込み{{selftagswindow?'△':'▽'}}</a>
      <div v-if="selftagswindow">
        <div v-if="login">
          <span class="tag">
            <input type="checkbox" id="goodtag" v-model="selfTag.goodtag" />
            <label for="goodtag" class="zyuuyou">いいねしたもの</label>
          </span>
          <span class="tag">
            <input type="checkbox" id="nogoodtag" v-model="selfTag.nogoodtag" />
            <label for="nogoodtag" class="zyuuyou">いいねしていないもの</label>
          </span>
          <span class="tag" v-if="false">
            <input type="checkbox" id="votetag" v-model="selfTag.votetag" />
            <label for="votetag" class="zyuuyou">投票した作品</label>
          </span>
        </div>
        <div v-else>
          いいねや投票をするには
          <a @click="loginButton()">ログイン</a>をしてください
        </div>
      </div>
      <br />
      <div id="leftleft" class="boxex" v-if="isGet">
        <div v-for="id in ids" :key="id">
          <div v-if="kaburi(items[id].tags, selected)&&log(id)">
            <div class="box">
              <div class="pen">
                <small>ペンネーム:{{items[id].name}}</small>
              </div>
              <div class="title">
                <a
                  @click="showbody(id,items[id].name,items[id].title,items[id].goodarray)"
                >{{items[id].title}}</a>
              </div>
              <hr style="margin: 0em;" />
              <p class="texts">{{items[id].intro}}</p>
              <div>
                <small>
                  <hr style="margin: 0em;margin-bottom:0.2em;" />
                  <span class="info">
                    タグ:
                    {{items[id].tags?items[id].tags.join(','):"タグなし"}}
                  </span>
                  <br />
                  <span class="info">いいね:{{(items[id].goodarray||[]).length}}件</span>
                </small>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <button v-if="!isLast">次の20件を表示</button>
      <div v-if="!isGet">ちょっと待ってね。今準備してるよ。</div>
    </div>
    <div v-else>
      <a id="back" @click="back()">戻る</a>
      <br />
      <h2>
        <span class="tag">閲覧は 5/1 から可能です。</span>
        <span class="tag">もうしばらくお待ちください</span>
      </h2>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Recent",
  props: {},
  data: () => ({
    start: true,
    offline: false,
    tagswindow: false,
    selftagswindow: false,

    dotCount: 0,
    dottime: null,
    ids: [],
    items: {},
    isGet: false,
    isLast: true,
    selectall: false,
    selectnull: false,
    tags: [
      "R15",
      "男主人公",
      "女主人公",
      "人外",
      "ファンタジー",
      "過去",
      "現代",
      "未来",
      "ハーレム",
      "群像劇",
      "青春",
      "コメディ",
      "タグなし"
    ],
    selected: [
      "R15",
      "男主人公",
      "女主人公",
      "人外",
      "ファンタジー",
      "過去",
      "現代",
      "未来",
      "ハーレム",
      "群像劇",
      "青春",
      "コメディ",
      "タグなし"
    ],
    login: false,
    uid: "",
    selfTag: {
      goodtag: true,
      mygoodarray: [],
      nogoodtag: true,
      votetag: false,
      myvote: ""
    }
  }),
  created() {
    // view が作られた時にデータを取得し、
    // そのデータは既に監視されています
    this.fetchData();
    this.onlinecheck();
  },
  watch: {
    // ルートが変更されたらこのメソッドを再び呼び出します
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      this.error = this.post = null;
      this.loading = true;
      firebase
        .database()
        .ref("/intros")
        .once("value")
        .then(snapshot => {
          this.items = snapshot.val();
          for (var id in this.items) {
            if (this.items[id].test !== true) {
              this.ids.push(id);
            }
          }
          this.ids = this.ids.reverse();
          this.isGet = true;
        })
        .catch(reason => {
          alert(reason);
        });
      this.loginchack();
    },
    tagAll() {
      if (this.selectall) {
        this.selected = this.tags;
        this.selectnull = false;
      }
    },
    tagNull() {
      if (this.selectnull) this.selected = [];
      this.selectall = false;
    },
    tagCheck() {
      if (this.selected == this.tags) {
        this.selectall = true;
      } else if (this.selected == []) {
        this.selectnull = true;
      } else {
        this.selectall = false;
        this.selectnull = false;
      }
    },
    kaburi(arr1, arr2) {
      arr1 = arr1 ? arr1 : ["タグなし"];

      return (
        [...arr1, ...arr2].filter(
          item => arr1.includes(item) && arr2.includes(item)
        ).length > 0
      );
    },
    onlinecheck() {
      var connectedRef = firebase.database().ref(".info/connected");
      connectedRef.on("value", snap => {
        if (snap.val() === true) {
          this.offline = false;
          clearInterval(this.dottime);
        } else {
          this.offline = true;
          this.dottime = setInterval(() => {
            this.dotCount = (this.dotCount + 1) % 6;
          }, 500);
        }
      });
    },
    log(id) {
      return (
        (this.selfTag.goodtag && this.selfTag.mygoodarray.indexOf(id) > -1) ||
        (this.selfTag.nogoodtag && !this.selfTag.mygoodarray.indexOf(id) > -1)
      );
    },
    showbody(id, name, title, goodarray) {
      this.$router.push({
        name: "body",
        params: {
          id: id,
          content: {
            name: name,
            title: title,
            goodarray: goodarray || []
          }
        }
      });
    },
    tagsWindow() {
      this.tagswindow = !this.tagswindow;
    },
    selfTagsWindow() {
      this.selftagswindow = !this.selftagswindow;
    },
    loginchack() {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.login = true;
          this.uid = user.uid;
          firebase
            .database()
            .ref("/myLoom/" + this.uid)
            .once("value")
            .then(snapshot => {
              if (snapshot.val()) {
                this.selfTag.mygoodarray =
                  Object.keys(snapshot.val().goodarray) || [];
                this.selfTag.vote = snapshot.val().vote || "";
              }
            })
            .catch(reason => {
              alert(reason);
              alert("reason");
            });
        } else {
          this.login = false;
          this.uid = "";
          this.selfTag.mygoodarray = [];
          this.selfTag.vote = "";
        }
      });
    },
    loginButton() {
      this.$router.replace({
        name: "Signin",
        params: {
          recent: true
        }
      });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  text-align: center;
}
#recent {
}
.tag {
  display: inline-block;
  margin-right: 20px;
}
#leftleft {
  text-align: left;
}
.boxex {
}
.box {
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  max-width: 900px;
  border-style: solid;
  border-color: black;
  border-width: thin;
  height: min-content;
}
.pen {
  padding-left: 2%;
  padding-right: 2%;
  margin-bottom: 5px;
}
.title {
  vertical-align: middle;
  padding-left: 4%;
  padding-right: 4%;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
.info {
  padding-left: 2%;
  padding-right: 2%;
}
.texts {
  margin-top: 0.1em;
  padding-left: 2%;
  padding-right: 2%;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
a {
  color: #42b983;
  cursor: pointer;
}
#back {
  margin-right: 80%;
  text-align: center;
}
</style>
